import styles from './EventList.scss'
import EventListItem from '../EventListItem/EventListItem'
import { Fragment } from 'react'
import anime from 'animejs';
//var parse = require('html-react-parser');
//import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class HelloFromPortal extends React.Component {
	render() {
		return (
			<h1>I am rendered through a Portal.</h1>
		);
	}
}

export default class EventListRender extends React.Component {
	render() {
		return (
			<div class="o-eventlist__outer" ref="eventlist">
				<ul class="o-eventlist">
					{this.props.events.map(event => <li class="o-eventlist__trigger">
						<EventListItem event={event} controller={this.props.controller} /></li>)}
				</ul>
			</div>
		);
	}

	renderPortal() {
		const selector_list = document.body.querySelectorAll('.o-eventlist')[0]

		if (selector_list) {
			return selector_list.innerHTML;
		}
	}

	componentDidMount() {
		//this.open();

	}

	componentDidUpdate() {
		this.open();
	}

	open() {
		let _this = this

		if (this.refs.eventlist) {
			this.refs.eventlist.setAttribute('data-in-animation', '1')
			this.refs.eventlist.style.width = '200%'
			this.refs.eventlist.style.transform = 'translateX(-50%)'

			anime({
				targets: this.refs.eventlist,
				translateX: 0,
				easing: 'easeInOutQuad',
				duration: 350,
				complete: function (anim) {
					//delete second container
					let container = _this.refs.eventlist.children[1]
					if (container) {
						container.remove()
					}
				}
			})
		}
	}
}
